import { createSlice } from '@reduxjs/toolkit';

export const selfEnrollmentSlice = createSlice({
    name: 'selfEnrollment',
    initialState: {
        prospect: null,
        loading: false,
        error: null,
        step:'welcome',
        subStep: 'welcome',
        prospectExists: false,
        serverError: null,
        missingConsent: false,
        alertData: null,
        codeError: null,
        consentPreview: null,
        cluster: null
    },
    reducers: {
        initSearchProspect: state => {
            state.loading = true;
            state.prospect = null;
            state.error = null;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setProspect: (state, action) => {
            state.loading = false;
            state.prospect = action.payload;
        },
        setStep: (state, action) => {
            state.step = action.payload;
        },
        setSubStep: (state, action) => {
            state.subStep = action.payload;
        },
        setProspectExists: (state, action) => {
            state.prospectExists = action.payload;
            state.loading = false;
        },
        setServerError: (state, action) => {
            state.serverError = action.payload;
            state.loading = false;
        },
        setMissingConsent: (state, action) => {
            state.missingConsent = action.payload;
            state.loading = false;
        },
        searchProspectError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        setCodeError: (state, action) => {
            state.codeError = action.payload;
        },
        setConsentPreview: (state, action) => {
            state.consentPreview = action.payload;
            state.loading = false;
        },
        setCluster: (state, action) => {
            state.cluster = action.payload;
        }
    }
});

export const { 
    initSearchProspect,
    setLoading,
    setProspect,
    setStep,
    setSubStep,
    searchProspectError,
    setProspectExists,
    setServerError,
    setMissingConsent,
    setCodeError,
    setConsentPreview,
    setCluster
} = selfEnrollmentSlice.actions;